<script>
import cloneDeep from 'lodash/cloneDeep';

import MatterDetails from '@/components/Agreements/MatterDetails';
import agreementTitle from '@/lib/agreement-title';
import base from '@/lib/agreement/base.json';
import kimAndKayne from '@/lib/agreement/kimAndKayne.json';
import featureFlag from '@/mixins/featureFlag';

import { analytics } from '../../firebase';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	components: {
		MatterDetails,
	},
	mixins: [featureFlag,validationMixin],
	data() {
		return {
			agreementData: cloneDeep(base),
			loading: false,
			error: '',
			isEdgeBrowser: false
		};
	},
	computed: {
		showTest() {
			return (
				process.env.NODE_ENV === 'development' ||
				this.featureEnabled('feature_test_data')
			);
		},
	},
	methods: {
		agreementTitle,
		createAgreement() {
			this.$v.agreementData.$touch();
			this.$refs.matterDetails.triggerValidation();
			if (this.$v.agreementData.$anyError) {
				return
			}
			this.loading = true;
			this.$store
				.dispatch('createAgreement', {
					...this.agreementData,
					title: agreementTitle(this.agreementData),
				})
				.then(({ id, error }) => {
					if (error) {
						this.error = 'Something unexpected went wrong.';
						this.$posthog.capture('agreement_creation_failed', {
							user_id: this.$store.state.user?.uid || null,
							role: this.$store.state.posthogRole || '',
							error_message: error.message || 'Unknown error',
							email: this.$store.state.user?.email || '',
							timestamp: new Date().toISOString(),
						});
						} else if (id) {
						analytics.logEvent('agreement_created');
						this.$posthog.capture('agreement_creation_completed', {
							agreement_id: id,
							user_id: this.$store.state.user?.uid || null,
							role: this.$store.state.posthogRole || '',
							timestamp: new Date().toISOString(),
						});
						this.$router.push({
							name: 'agreement',
							params: { id },
						});
					}
					this.loading = false;
				});
		},
		detectEdgeBrowser() {
            if (document.documentMode) {
                this.isEdgeBrowser = true;
                return;
            }

            if ('msLaunchUri' in navigator || 'msMaxTouchPoints' in navigator) {
                this.isEdgeBrowser = true;
                return;
            }
            const isChromium = window.chrome;
            const isEdgeHTML = !isChromium && 'CSS' in window;
            
            if (isChromium) {
                this.isEdgeBrowser = navigator.userAgent.indexOf("Edg/") !== -1;
            } else if (isEdgeHTML) {
                this.isEdgeBrowser = true;
            }
        },
		loadTestData() {
			this.agreementData = kimAndKayne;
			this.createAgreement();
		},
	},
	mounted() {
        const containerElement = this.$el.querySelector('.container-element');
        this.$nextTick(() => {
            const isEdge = 
                /Edge\/\d./i.test(navigator.userAgent) || 
                /Edg/i.test(navigator.userAgent);
            
            if (isEdge) {
                const container = this.$el.querySelector('.container-element');
                if (container) {
                    container.classList.add('matter-container');
                }
            }
        });
    },
	validations:{
		agreementData:{
			partner1:{
				name:{
					first:{
						required
					},
					last:{
						required
					}
				}
			},
			partner2:{
				name:{
					first:{
						required
					},
					last:{
						required
					}
				}
			},
			agreement:{
				updatedProvinceOfAgreement:{
					required
				},
				year:{
					required
				}
			}
		}
	}
};
</script>

<style scoped>
    .matter-container {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        max-height: 60dvh !important;
        padding-bottom: 3.5rem !important;      
    }   
    .card-body {
         margin-bottom: 3rem;
    }
</style>

<template>
		<b-overlay
			spinner-variant="primary"
			:show="loading"
			rounded="sm"
			opacity="0.5"
			blur="2px"
			variant="white"
		>
		<b-container class="mt-5 container-element">
			<matter-details ref="matterDetails" :agreement-data="agreementData">
				<div class="actions">
					<b-button
						variant="primary"
						@click="createAgreement(agreementData)"
						:disabled="$v.agreementData.$anyError"
						>Create</b-button
					>
					<b-button v-if="showTest" @click="loadTestData()" class="ml-2">
						Test
					</b-button>
					<div v-if="$v.agreementData.$anyError" class="invalid-feedback d-block col-12 pl-0">Please fill all the required fields first</div>
				</div>
				<div v-if="error">
					{{ error }}
				</div>
			</matter-details>
		</b-container>
		</b-overlay>
</template>
